import errorModalHtml from "./error-modal.html";

export default class ErrorModal {

    constructor() {
        $("body").append(errorModalHtml);
        this.modal = $("#errorModal");
    }

    show(content) {
        const self = this;
        self.modal.find("#errorDialogContent").first().html(content);
        self.modal.modal("show");
    }

    close() {
        const self = this;
        self.modal.modal("hide");
    }
}